<div class="profile-flex-container">
  <div class="profile-flex">
    <app-profile-sidebar activePage="my-cards"  class="z-2 profile-sidebar m-w-100" ></app-profile-sidebar>

    <h2 class="profile-title">{{ "MY_CARDS.SAVED_CARDS" | translate }}</h2>
    <p class="profile-description mt-3">{{ "MY_CARDS.SAVED_CARDS_DESCRIPTION" | translate }}</p>

    <div class="user-saved-cards-container" *ngIf="userCards">
      <div class="app-credit-card-container" *ngFor="let card of userCards">
        <div class="app-credit-card-bg" [ngClass]="{ 'active': card.isDefault }">
          <app-credit-card class="app-credit-card" userCardClass="" [card]="card"></app-credit-card>

          <div class="button-container">
            <button (click)="deleteCard(card)" class="btn btn-default">{{ "MY_CARDS.DELETE" | translate }}</button>
            <button (click)="setAsDeafultCreditCard(card.id)" class="btn btn-default" *ngIf="!card.isDefault">{{ "MY_CARDS.SET_AS_PRIMARY" | translate }}</button>
          </div>
        </div>

        <p class="error-message" *ngIf="errorMessageDeleteCard && errorMessageDeleteCardId === card.id">{{ errorMessageDeleteCard }}</p>
      </div>
    </div>

    <div class="add-new-card-container mt-5">
      <span class="profile-title mt-5" *ngIf="userCards.length > 0">{{ "MY_CARDS.ADD_NEW" | translate }}</span>
      <p class="profile-description mb-5 mt-3">{{ "MY_CARDS.ADD_NEW_DESCRIPTION" | translate }}</p>

      <iframe id="paymentIframe" name="paymentIframe" class="payment-iframe"></iframe>

      <form ngNoForm id="pgw-card" name="pgw" method="post" action="{{paymentUrl}}/user/monri/save-card" target="paymentIframe">
        <input type="hidden" name="lang" [value]="paymentLanguage()"/>
        <input type="hidden" name="opis" value="{{firstName}} {{lastName}}" />
        <input type="hidden" name="redirect_url" [value]="redirectUrl" />
        <input type="hidden" name="redirect_url_err" [value]="redirectUrlErr"/>
        <input type="hidden" name="wpId" [value]="wpId"/>

        <div class="add-new" *ngIf="showAddCardButton">
          <span class="mt-2">{{ "MY_CARDS.ADD_NEW_CARD_BUTTON" | translate }}:</span>

          <div class="flex mt-5 mb-5">
            <img src="img/payment/visa.png" />
            <img src="img/payment/mastercard.png" />
            <img src="img/payment/maestro.png" />
            <img src="img/payment/diners.png" />
          </div>

          <div class="flex flex-end">
            <button (click)="addCard()" class="btn btn-secondary">{{ "MY_CARDS.ADD_NEW_CARD_BUTTON" | translate }}</button>
          </div>
        </div>
      </form>
    </div>

    <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>
</div>
